import { gsap } from 'gsap/all'

export const accordion = {
  accordion: document.querySelector('.accordion'),
  items: document.querySelectorAll<HTMLElement>('.accordion__item'),

  init: () => {
    const acc = accordion

    Array.prototype.forEach.call(acc.items, (item: HTMLElement) => {
      const head = item.firstElementChild as HTMLButtonElement

      head.addEventListener('click', () => {
        if (item.ariaExpanded == 'false') {
          acc.openBody(item)
        } else {
          acc.closeBody(item)
        }
      })
    })
  },

  openBody: (item) => {
    item.ariaExpanded = 'true'

    gsap.fromTo(
      item.querySelector('.accordion__body'),
      { height: 0 },
      { height: 'auto', clearProps: 'height' }
    )
  },

  closeBody: (item) => {
    gsap.set(item.querySelector('.accordion__body'), { height: 'auto' })

    gsap.to(item.querySelector('.accordion__body'), {
      clearProps: 'height',
      height: 0,
      delay: 0.1,
      onStart: () => {
        item.ariaExpanded = 'false'
      },
    })
  },
}
